import PropTypes from 'prop-types';
import React from 'react';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import translate from '../../commonComponents/translate';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import { useSanitize } from '../../services/customHooks';

function PrivacyPolicy(props) {
  const { t, privacyPolicy } = props;
  const privacy = useSanitize(privacyPolicy);
  return (
    <Title title={t('landing_privacyPolicy')}>
      <ContentContainer>
        <SubHeader title={t('landing_privacyPolicy')} />
        <div className="m-content">
          <div
            className="container bg-white pt-2"
            dangerouslySetInnerHTML={{
              __html: privacy,
            }}
          />
        </div>
      </ContentContainer>
    </Title>
  );
}

PrivacyPolicy.propTypes = {
  t: PropTypes.func.isRequired,
  privacyPolicy: PropTypes.string.isRequired,
};

export default translate(PrivacyPolicy);
